<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const props = defineProps({
    spotMessage: {
      type: String,
      default: null
    }
  });
</script>

<template>
  <div v-if="props.spotMessage" class="jwx-toolbar-header__message">
    <p class="jwx-toolbar-header__message-label">{{ t('common.specialNote') }}</p>
    <p v-html="props.spotMessage" class="jwx-toolbar-header__message-text"></p>
  </div>
</template>